var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 老哥啊 大发慈悲啊 我瞅瞅咋回事1 "),_c('div',{staticClass:"box"},[_c('van-image',{staticClass:"inner-img",attrs:{"src":_vm.src,"alt":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }